import {
  getProductGtagData, parseProductCustomMetricsFromTags, parseTagsForProductCategories,
} from './helpers';
import {
  BundledPotProductAndVariantInfo, MainProductAndVariantInfo,
  SearchaniseProductAndVariantInfo,
} from './types';

export const logProductViewEvent = (
  mainProductVariantInfo: MainProductAndVariantInfo,
  bundledPotVariant?: BundledPotProductAndVariantInfo,
): void => {
  const dataLayerViewEvent = {
    event: 'view_item',
    ecommerce: {
      items: getProductGtagData(mainProductVariantInfo, bundledPotVariant),
    },
  };

  global.dataLayer.push({ ecommerce: null });
  global.dataLayer.push(dataLayerViewEvent);
};

export const logProductListViewEvent = (products: MainProductAndVariantInfo[]): void => {
  const items = products.map(
    (productAndVariantInfo) => getProductGtagData(productAndVariantInfo),
  )
    .flat()
    .map((gtagData, index) => ({
      ...gtagData,
      index: index + 1,
    }));

  const dataLayerViewEvent = {
    event: 'view_item_list',
    ecommerce: {
      items,
    },
  };

  global.dataLayer.push({ ecommerce: null });
  global.dataLayer.push(dataLayerViewEvent);
};

export const logProductSelectEvent = (
  productVariantInfo: MainProductAndVariantInfo,
): void => {
  const dataLayerViewEvent = {
    event: 'select_item',
    ecommerce: {
      items: getProductGtagData(productVariantInfo),
    },
  };

  global.dataLayer.push({ ecommerce: null });
  global.dataLayer.push(dataLayerViewEvent);
};

const getSearchaniseProductGtagData = (productVariantInfo: SearchaniseProductAndVariantInfo) => {
  const { product, variant, metadata } = productVariantInfo;

  const productTags = product.tags;
  const productQuantity = 1;
  let collection = null;
  let productIndex = 1;

  if (metadata) {
    collection = metadata.collection;
    productIndex = metadata.productIndex === undefined ? 1 : (metadata.productIndex + 1);
  }

  const productOriginalPrice = variant.compare_at_price || variant.price;
  const productDiscount = variant.compare_at_price
    ? (variant.compare_at_price - variant.price) : 0;

  const productCategoryData = parseTagsForProductCategories(productTags);
  const tagBasedMetrics = parseProductCustomMetricsFromTags(product.tags);

  const mainProductData = {
    item_id: `${product.id}`,
    item_name: product.title,
    affiliation: 'Lively Root - Online Shop',
    coupon: null as string | null,
    currency: 'USD',
    discount: productDiscount,
    index: productIndex,
    item_brand: product.vendor,
    item_list_id: collection?.id ? `${collection.id}` : null,
    item_list_name: collection?.title || null,
    item_variant: variant.title,
    price: productOriginalPrice,
    quantity: productQuantity,
    ...productCategoryData,
    ...tagBasedMetrics,
    item_availability: variant.available,
    item_size: variant.options.Size || null,
    item_color: variant.options.Color || null,
  };

  return mainProductData;
};

export const logSearchaniseProductListViewEvent = (
  products: SearchaniseProductAndVariantInfo[],
): void => {
  const items = products.map(
    (productAndVariantInfo) => getSearchaniseProductGtagData(productAndVariantInfo),
  );

  const dataLayerViewEvent = {
    event: 'view_item_list',
    ecommerce: {
      items,
    },
  };

  global.dataLayer.push({ ecommerce: null });
  global.dataLayer.push(dataLayerViewEvent);
};

export const logSearchaniseProductSelectEvent = (
  productVariantInfo: SearchaniseProductAndVariantInfo,
): void => {
  const dataLayerViewEvent = {
    event: 'select_item',
    ecommerce: {
      items: getSearchaniseProductGtagData(productVariantInfo),
    },
  };

  global.dataLayer.push({ ecommerce: null });
  global.dataLayer.push(dataLayerViewEvent);
};
